/** Whether the machine on this desk belongs to the account in this browser. */

import { Banner } from "@/components/ui";

import { useMachineOwnership } from "./queries";

export interface MachineAccountNoticeProps {
  /** `PairingScreen.machine_id`, null until this machine is paired. */
  readonly machineId: string | null | undefined;
}

/** Renders only when the machine is paired to an account other than the signed-in one. */
export function MachineAccountNotice({ machineId }: MachineAccountNoticeProps) {
  const ownership = useMachineOwnership(machineId);

  if (ownership !== "somebody_else") return null;

  return (
    <Banner tone="danger" title="This machine is paired to another account">
      You are signed in as somebody else. Anything you load here reaches the
      account that pairs this machine, not yours. Unpair it below and pair it
      again while signed in as the account that should own it.
    </Banner>
  );
}
